/* Moonou A/B-Experimente ueber Mixpanel Feature Flags (EU-Projekt).
 *
 * WAS DIESES SKRIPT TUT
 * Es blendet einzelne Sections (oder ein einzelnes Element darin) je nach
 * Mixpanel-Zuteilung ein oder aus. Mehr Granularitaet gibt es bewusst nicht —
 * ein Test = eine Sichtbarkeit.
 *
 * WIE EIN EXPERIMENT AN DIE SEITE KOMMT
 * snippets/moonou-ab-flag.liquid rendert pro Section einen unsichtbaren Marker:
 *   <div data-moonou-experiment="<Flag-Key aus Mixpanel>"
 *        data-ab-behavior="show_on_treatment" | "hide_on_treatment"
 *        data-ab-target="#shopify-section-<id>"     CSS-Selektor des Ziels
 *        data-ab-style="<uid>"                      Anti-Flacker-Style-Tag
 *        data-ab-hook="sale_countdown"              optional, s. u.
 *        hidden></div>
 * Dieses Skript sucht alle Marker; ohne Marker passiert gar nichts. Mehrere
 * Marker mit unterschiedlichen Flags laufen parallel, mehrere Marker mit
 * DEMSELBEN Flag teilen sich eine Zuteilung (und damit ein Exposure).
 *
 * DER FLAG-KEY IST GLEICHZEITIG DER NAME
 * Cache-Schluessel und QA-Schalter leiten sich direkt aus dem Flag-Key ab, damit
 * das Inline-Skript im Snippet (das VOR der ersten Zeichnung laeuft) denselben
 * Schluessel bilden kann, ohne einen zweiten Namen zu kennen.
 *
 * FLACKER-STRATEGIE (bewusst gewaehlt, siehe Bericht)
 * Bei "show_on_treatment" steht das Ziel serverseitig schon versteckt im HTML
 * (Style-Tag aus dem Snippet). Es ist also von der ersten Zeichnung an
 * unsichtbar; erst die Zuteilung blendet es ein. Der umgekehrte Weg (erst
 * zeigen, dann fuer control wieder ausblenden) wurde verworfen: er behandelt
 * die Kontrollgruppe teilweise mit und macht die Messung stumpf.
 * Bei "hide_on_treatment" passiert serverseitig nichts — das Element gehoert
 * zur Seite, nur die treatment-Gruppe verliert es.
 * Drei Sicherungen daempfen die Wartezeit:
 *   1. Zuteilung aus dem letzten Besuch (localStorage, 12 h) wird schon im
 *      Inline-Skript des Snippets VOR der ersten Zeichnung angewendet —
 *      Wiederkehrer sehen null Verzoegerung.
 *   2. Mixpanel wird auf Seiten mit Experiment sofort geladen statt erst bei
 *      der ersten Interaktion (Hook window.moonouLoadMixpanel).
 *   3. Kommt binnen REVEAL_TIMEOUT_MS keine Antwort, faellt das Ziel auf den
 *      URSPRUNGSZUSTAND der Seite ohne Test zurueck — und der ist in beiden
 *      Richtungen "sichtbar". Diese Besucher zaehlen nicht ins Experiment, weil
 *      ohne gelesenen Flag auch kein Exposure entsteht. Trifft die Antwort
 *      spaeter doch noch ein, wird sie angewendet — dann lieber ein kurzes
 *      Umschalten als eine verfaelschte Zuteilung.
 *
 * SOLANGE DER FLAG NICHT LAEUFT
 * Antwortet Mixpanel mit einem Ersatzwert (Flag fehlt, ist aus oder das
 * Experiment ist noch nicht gestartet), gilt das als "kein Experiment": das
 * Ziel bleibt sichtbar. Der Flag darf nur mit einer echten Zuteilung etwas
 * verstecken.
 *
 * EXPOSURE
 * Das $experiment_started-Event schickt die Mixpanel-SDK selbst, sobald der
 * Flag gelesen wird (nachgewiesen im Netzwerk: "Experiment name", "Variant
 * name", $experiment_type=feature_flag, dieselbe distinct_id wie "Page View").
 * Hier wird bewusst KEIN eigenes Exposure-Event getrackt, sonst zaehlt
 * Mixpanel jede Zuteilung doppelt.
 *
 * IDENTITAET
 * Es wird dieselbe mixpanel-Instanz benutzt wie das uebrige Tracking
 * (snippets/moonou-tracking-head.liquid), also dieselbe distinct_id wie
 * "Page View", "Add to Cart" und "Purchase". Kein eigener Client, kein
 * eigener Speicher.
 *
 * SONDERFALL SALE-COUNTDOWN
 * Traegt der Marker data-ab-hook="sale_countdown" (oder zeigt das Ziel auf ein
 * [data-sale-countdown]-Element), laeuft die Sichtbarkeit ueber
 * window.MoonouSaleCountdown.setVisible() statt ueber display:none. Sonst
 * wuerden sich zwei Mechaniken um dasselbe Element streiten — und ein
 * abgelaufener Countdown wuerde per "treatment" wiederbelebt.
 *
 * QA-SCHALTER (ohne Mixpanel, ohne Exposure):
 *   ?moonou_exp_<flag-key>=treatment
 *   ?moonou_exp_<flag-key>=control
 */
(function () {
  if (window.MoonouExperiments) return;

  /* Muss zur TTL im Inline-Skript des Snippets passen (12 Stunden). */
  var CACHE_TTL_MS = 12 * 60 * 60 * 1000;
  /* So lange bleibt ein Ziel hoechstens verborgen, wenn keine Antwort kommt. */
  var REVEAL_TIMEOUT_MS = 1500;
  /* Takt und Geduld beim Warten auf die geladene Mixpanel-Bibliothek. */
  var POLL_MS = 50;
  var POLL_MAX_MS = 15000;
  /* Geduld beim Warten auf einen Sichtbarkeits-Hook (moonou-sale-countdown.js). */
  var HOOK_MAX_WAIT_MS = 5000;

  function cacheKey(name) {
    return 'moonou_exp_' + name;
  }

  function readCache(name) {
    try {
      var raw = window.localStorage.getItem(cacheKey(name));
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.v !== 'string' || typeof data.t !== 'number') return null;
      if (Date.now() - data.t > CACHE_TTL_MS) return null;
      return data.v;
    } catch (e) {
      /* Privater Modus / gesperrter Speicher: der Cache ist nur Komfort. */
      return null;
    }
  }

  function writeCache(name, variant) {
    try {
      window.localStorage.setItem(cacheKey(name), JSON.stringify({ v: variant, t: Date.now() }));
    } catch (e) {
      /* siehe oben — kein Fehlerfall */
    }
  }

  function clearCache(name) {
    try {
      window.localStorage.removeItem(cacheKey(name));
    } catch (e) {
      /* siehe oben — kein Fehlerfall */
    }
  }

  /* QA-Schalter aus der Adresszeile, z. B. ?moonou_exp_mein-flag=control */
  function urlOverride(name) {
    try {
      return new URLSearchParams(window.location.search).get('moonou_exp_' + name);
    } catch (e) {
      return null;
    }
  }

  function flagsAvailable() {
    var mp = window.mixpanel;
    return !!(mp && mp.flags && typeof mp.flags.get_variant === 'function');
  }

  /* get_variant liefert entweder eine echte Zuteilung
       { key, value, variant_source: "network" | "local", experiment_id, … }
     oder einen Ersatzwert
       { variant_source: "fallback", fallback_reason: "FLAG_NOT_FOUND" }.
     Nur die echte Zuteilung darf das Experiment steuern und gecacht werden —
     ein Ersatzwert heisst "kein Experiment", nicht "Kontrollgruppe". Solange
     der Flag in Mixpanel noch nicht laeuft, bleibt das Ziel also normal
     sichtbar statt fuer alle verschwunden. */
  function variantFrom(result) {
    if (!result || typeof result !== 'object') return null;
    if (result.variant_source === 'fallback') return null;
    if (typeof result.key === 'string') return result.key;
    if (typeof result.value === 'string') return result.value;
    return null;
  }

  /* Mixpanel wird im Theme absichtlich verzoegert geladen (erste Interaktion,
     spaetestens nach 8 s). Fuer ein Experiment ueber dem Falz ist das zu spaet,
     deshalb ziehen wir den Ladevorgang genau auf diesen Seiten vor. */
  function pullMixpanelForward() {
    if (typeof window.moonouLoadMixpanel === 'function') {
      window.moonouLoadMixpanel();
      return true;
    }
    console.warn('[moonou-exp] Kein Mixpanel-Ladehaken gefunden, Zuteilung wartet auf den normalen Ladeweg.');
    return false;
  }

  var experiments = {};

  function runAppliers(exp, variant, source) {
    for (var i = 0; i < exp.appliers.length; i++) {
      try {
        exp.appliers[i](variant, source);
      } catch (err) {
        console.warn('[moonou-exp] Anwenden der Variante fehlgeschlagen:', exp.name, err);
      }
    }
  }

  function settle(exp, variant, source) {
    if (exp.timer) {
      clearTimeout(exp.timer);
      exp.timer = null;
    }
    exp.variant = variant;
    exp.source = source;
    exp.settled = true;
    if (source === 'mixpanel' && typeof variant === 'string') {
      writeCache(exp.name, variant);
    } else if (source === 'ohne-zuteilung') {
      /* Der Flag laeuft nicht (mehr). Alte Zuteilung wegraeumen, sonst haengt
         der naechste Aufruf noch bis zu 12 Stunden an einem toten Test. */
      clearCache(exp.name);
    }
    runAppliers(exp, variant, source);
  }

  function askMixpanel(exp) {
    var startedAt = Date.now();

    function poll() {
      if (flagsAvailable()) {
        var pending;
        try {
          /* Das Lesen selbst loest das Exposure-Event $experiment_started aus —
             deshalb wird der Flag genau einmal pro Seitenaufruf gelesen. */
          pending = window.mixpanel.flags.get_variant(exp.flag);
        } catch (err) {
          console.warn('[moonou-exp] Flag-Abfrage fehlgeschlagen:', exp.flag, err);
          settle(exp, null, 'fehler');
          return;
        }
        Promise.resolve(pending).then(
          function (result) {
            var variant = variantFrom(result);
            settle(exp, variant, variant === null ? 'ohne-zuteilung' : 'mixpanel');
          },
          function (err) {
            console.warn('[moonou-exp] Flag-Abfrage abgelehnt:', exp.flag, err);
            settle(exp, null, 'fehler');
          }
        );
        return;
      }
      if (Date.now() - startedAt > POLL_MAX_MS) {
        console.warn('[moonou-exp] Mixpanel-Flags nicht verfuegbar, kein Exposure fuer:', exp.name);
        return;
      }
      window.setTimeout(poll, POLL_MS);
    }

    poll();
  }

  /* name: Cache-/QA-Name (= Flag-Key), flag: Flag-Key in Mixpanel,
     apply(variant, quelle): wendet die Variante an.
     apply(null, …) heisst "keine Zuteilung, Ursprungszustand".
     Mehrfachaufruf mit demselben Namen haengt einen weiteren Anwender an —
     die Zuteilung (und damit das Exposure) passiert trotzdem nur einmal. */
  function register(options) {
    if (!options || !options.name || !options.flag || typeof options.apply !== 'function') {
      console.warn('[moonou-exp] Unvollstaendige Experiment-Definition:', options);
      return null;
    }

    var existing = experiments[options.name];
    if (existing) {
      existing.appliers.push(options.apply);
      /* Nachzuegler bekommt sofort den Stand, den die anderen schon haben. */
      if (existing.settled) {
        options.apply(existing.variant, existing.source);
      } else if (existing.cached) {
        options.apply(existing.cached, 'cache');
      }
      return existing;
    }

    var exp = {
      name: options.name,
      flag: options.flag,
      appliers: [options.apply],
      variant: null,
      source: null,
      cached: null,
      settled: false,
      timer: null
    };
    experiments[options.name] = exp;

    var forced = urlOverride(exp.name);
    if (forced) {
      /* QA-Weg: bewusst ohne Mixpanel, damit keine Testdaten ins Experiment laufen. */
      settle(exp, forced, 'url');
      return exp;
    }

    exp.cached = readCache(exp.name);
    if (exp.cached) runAppliers(exp, exp.cached, 'cache');

    /* Fallschirm: bleibt die Antwort aus, gilt wieder der Ursprungszustand.
       Eine gecachte Zuteilung aus dem letzten Besuch bleibt davon unberuehrt —
       sie ist die bessere Auskunft als "gar keine". */
    exp.timer = window.setTimeout(function () {
      exp.timer = null;
      if (exp.settled || exp.cached) return;
      runAppliers(exp, null, 'timeout');
    }, REVEAL_TIMEOUT_MS);

    pullMixpanelForward();
    askMixpanel(exp);
    return exp;
  }

  /* ---- Sichtbarkeit anwenden ---- */

  /* Das serverseitige Anti-Flacker-Style-Tag hat seine Schuldigkeit getan,
     sobald wir entschieden haben: ab hier steuert das Element selbst. Bliebe
     es stehen, koennte sein display:none !important kein Einblenden zulassen. */
  function dropHideStyle(uid) {
    if (!uid) return;
    var tag = document.querySelector('style[data-moonou-ab-hide="' + uid + '"]');
    if (tag && tag.parentNode) tag.parentNode.removeChild(tag);
  }

  /* Aus display:none heraus greift keine CSS-Transition, deshalb blendet eine
     kurze Keyframe-Animation die Countdown-Pill ein (respektiert
     prefers-reduced-motion ueber das Stylesheet). */
  function markReveal(el) {
    if (!el || el.classList.contains('moonou-sale-countdown--hidden')) return;
    if (el.classList.contains('mch-sale-promo--ab-reveal')) return;
    el.classList.add('mch-sale-promo--ab-reveal');
  }

  function usesCountdownHook(marker, target) {
    if (marker.getAttribute('data-ab-hook') === 'sale_countdown') return true;
    return !!(target && target.hasAttribute && target.hasAttribute('data-sale-countdown'));
  }

  /* moonou-sale-countdown.js steht im HTML NACH diesem Laeufer, beide mit
     defer. Bei einer sofortigen Zuteilung (QA-Schalter oder Cache) ist der Hook
     also noch nicht da. Deshalb warten statt aufgeben — sonst bliebe die Pill
     fuer die Kontrollgruppe sichtbar. */
  function whenCountdownReady(callback) {
    var api = window.MoonouSaleCountdown;
    if (api && typeof api.setVisible === 'function') {
      callback(api);
      return;
    }
    var startedAt = Date.now();
    (function poll() {
      var ready = window.MoonouSaleCountdown;
      if (ready && typeof ready.setVisible === 'function') {
        callback(ready);
        return;
      }
      if (Date.now() - startedAt > HOOK_MAX_WAIT_MS) {
        console.warn('[moonou-exp] Sale-Countdown-Hook fehlt, Sichtbarkeit bleibt unveraendert.');
        callback(null);
        return;
      }
      window.setTimeout(poll, POLL_MS);
    })();
  }

  /* visible: true = zeigen, false = verstecken.
     natural: true = "kein Experiment, Theme entscheidet" (nur fuer den Hook
     relevant — ein abgelaufener Countdown bleibt dann abgelaufen).
     done(): erst danach darf das Anti-Flacker-Style-Tag weg. */
  function setVisible(marker, target, visible, natural, done) {
    if (usesCountdownHook(marker, target)) {
      whenCountdownReady(function (api) {
        if (api) api.setVisible(visible ? (natural ? null : true) : false);
        /* Auch ohne Hook muss das Style-Tag weg, sonst bliebe die Pill wegen
           eines Ladefehlers dauerhaft unsichtbar. */
        done();
        if (visible) markReveal(target);
      });
      return;
    }
    if (!target) {
      done();
      return;
    }
    if (visible) {
      target.style.removeProperty('display');
      target.removeAttribute('aria-hidden');
    } else {
      target.style.setProperty('display', 'none', 'important');
      target.setAttribute('aria-hidden', 'true');
    }
    done();
  }

  /* Aus Variante + Verhalten wird Sichtbarkeit.
     Ohne Zuteilung (variant === null) gilt in BEIDEN Richtungen der
     Ursprungszustand der Seite ohne Test — und der ist "sichtbar". */
  function visibilityFor(variant, behavior) {
    if (variant === null) return true;
    var isTreatment = variant === 'treatment';
    if (behavior === 'hide_on_treatment') return !isTreatment;
    return isTreatment;
  }

  function bindMarker(marker) {
    if (marker.getAttribute('data-moonou-ab-bound') === 'true') return;
    var flag = (marker.getAttribute('data-moonou-experiment') || '').trim();
    if (!flag) {
      console.warn('[moonou-exp] Marker ohne Flag-Key gefunden, Experiment laeuft nicht.', marker);
      return;
    }
    marker.setAttribute('data-moonou-ab-bound', 'true');

    var behavior = marker.getAttribute('data-ab-behavior') === 'hide_on_treatment'
      ? 'hide_on_treatment'
      : 'show_on_treatment';
    var selector = marker.getAttribute('data-ab-target') || '';
    var uid = marker.getAttribute('data-ab-style');

    var target = null;
    if (selector) {
      try {
        target = document.querySelector(selector);
      } catch (err) {
        console.warn('[moonou-exp] Ungueltiger Ziel-Selektor:', selector, err);
      }
    }
    if (!target) {
      console.warn('[moonou-exp] Ziel-Element nicht gefunden:', selector, '— Experiment', flag, 'laeuft nicht.');
      /* Wichtig: das Anti-Flacker-Style-Tag muss trotzdem weg, sonst bliebe ein
         Element wegen eines Tippfehlers dauerhaft unsichtbar. */
      dropHideStyle(uid);
      return;
    }

    register({
      name: flag,
      flag: flag,
      apply: function (variant, source) {
        var visible = visibilityFor(variant, behavior);
        setVisible(marker, target, visible, variant === null, function () {
          dropHideStyle(uid);
        });
        if (source === 'mixpanel') {
          /* Ein Wort in die Konsole, damit die Zuteilung im QA nachvollziehbar ist. */
          console.info('[moonou-exp]', flag, '=', variant, '→', visible ? 'sichtbar' : 'verborgen');
        }
      }
    });
  }

  function boot() {
    var markers = document.querySelectorAll('[data-moonou-experiment]');
    for (var i = 0; i < markers.length; i++) bindMarker(markers[i]);
  }

  window.MoonouExperiments = {
    register: register,
    boot: boot,
    variantOf: function (name) {
      return experiments[name] ? experiments[name].variant : null;
    },
    stateOf: function (name) {
      var exp = experiments[name];
      if (!exp) return null;
      return { variant: exp.variant, source: exp.source, settled: exp.settled, flag: exp.flag };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
